type IconProps = { className?: string };

export function OrangeBrandIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden>
      <rect width="24" height="24" rx="6" fill="#FF7900" />
      <path
        fill="#fff"
        d="M6.2 16.5V7.5h2.1l3.4 5.2V7.5h2.1v9H11.7L8.3 11.3v5.2H6.2zm8.8 0V7.5h2.1v9H15z"
      />
    </svg>
  );
}
